import React from 'react';

const Footer = () => {
  return (
    <div className="w-full bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex flex-col md:flex-row md:items-center gap-2 text-sm text-gray-600">
          <div className="font-medium">
            © Bitvavo B.V. 2025
          </div>
          
          <div className="md:flex-1 md:text-center">
            Registered at the Dutch Chamber of Commerce, number 68743424. Trading digital assets such as Bitcoin involves significant risks.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;